/**
 * Feature flags configuration
 * Controls which features are enabled/disabled based on environment variables
 */

export const features = {
  /**
   * Controls whether users can cross-link email/phone accounts during signup
   * When false, the AlternateContactPhase is skipped in the auth flow
   */
  accountCrossLinking: import.meta.env.VITE_ENABLE_ACCOUNT_CROSS_LINKING !== 'false',

  /**
   * EMERGENCY BYPASS: Allows "Start Program" button to be clickable even if
   * m-checkout-form fields are incomplete.
   *
   * USE WITH CAUTION: This is intended for emergency situations where users
   * are blocked by validation issues (e.g., phone verification bugs).
   *
   * Set VITE_BYPASS_CHECKOUT_VALIDATION=true in Render environment to enable.
   * Default is false (validation enforced).
   */
  bypassCheckoutValidation: import.meta.env.VITE_BYPASS_CHECKOUT_VALIDATION === 'true',

  /**
   * LENIENT PHONE VERIFICATION: When enabled, clicking "Send Code" (attempting
   * verification) is enough to satisfy the phone requirement — the user does NOT
   * need to complete OTP verification.
   *
   * When disabled (default), full OTP verification is required.
   *
   * Use this as a transitional measure while phone verification edge cases are
   * being resolved. Once verification is fully stable, set to false.
   *
   * Set VITE_LENIENT_PHONE_VERIFICATION=true in Render environment to enable.
   */
  lenientPhoneVerification: import.meta.env.VITE_LENIENT_PHONE_VERIFICATION === 'true'
};

/**
 * Type-safe feature flag checker
 */
export function isFeatureEnabled(feature: keyof typeof features): boolean {
  return features[feature];
}

/**
 * Get all enabled features as a read-only object
 */
export function getEnabledFeatures(): Readonly<typeof features> {
  return features;
}
